<section class="dashboard-section" [class.bordered]="bordered" [attr.data-test]="dataTest || null">
    <h3 class="section-title" *ngIf="title">
        {{ title }}
        <ng-content select="[headerActions]"></ng-content>
    </h3>
    <ng-content></ng-content>
</section>
